// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"48":"shareModule","151":"Test","274":"Home"}[chunkId] + "." + {"48":"0c7ecbf5","151":"0d1af959","274":"df58caa2"}[chunkId] + ".js";
};